import { ChangeEvent } from "react";
import * as xlsx from "xlsx";
import { JOIN_NOW, ONGOING_REGISTERATION, PAST } from "./config/constants";

export const startWithUpperCase = (word: string): string => {
  let modelWord = word.toLowerCase();
  let newWord = "";

  for (let i = 0; i < modelWord.length; i++) {
    newWord += i === 0 ? modelWord[i].toUpperCase() : modelWord[i];
  }

  return newWord;
};

export const properlizeWords = (words: string): string => {
  let strArray = words.split(" ");
  let newWords = strArray.length > 0 ? startWithUpperCase(strArray[0]) : "";

  for (let i = 1; i < strArray.length; i++) {
    newWords += ` ${startWithUpperCase(strArray[i])}`;
  }

  return newWords;
};

/**
 * punctates the number(e.g from 12345 to 12,345)
 * @param {*} number the number to be punctuated
 * @returns
 */
export function punctuateNumber(number: number) {
  //convert the number to a string
  let str = number.toString();
  let newStr = "";

  let itrCount = 0; //iteration-count
  for (let index = str.length - 1; index >= 0; index--) {
    newStr +=
      ++itrCount % 3 === 0 && index !== 0 ? `${str[index]},` : `${str[index]}`;
  }

  str = ""; //wipe the string
  //reverse the new string
  for (let index = newStr.length - 1; index >= 0; index--) {
    str += newStr[index];
  }

  return str;
}

export function pathContains(path: string, contained: string) {
  const nodes = path.split("/");

  for (const node of nodes) {
    if (node === contained) {
      return true;
    }
  }
  return false;
}

export const camelCase2Words = (camel: string) => {
  if (camel.length === 0) {
    return camel;
  }

  if (camel[0] !== camel[0].toLowerCase()) {
    return camel;
  }

  let words = "";

  for (let i = 0; i < camel.length; i++) {
    words +=
      camel[i].toLowerCase() === camel[i] ? `${camel[i]}` : ` ${camel[i]}`;
  }

  return words;
};

export const mkHandleImport = (
  setData4Import: (data: any) => void,
  setData4ImportSet: (data: boolean) => void
) => {
  return (event: ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = (e) => {
        const data = new Uint8Array(e.target?.result as ArrayBuffer);
        const workbook = xlsx.read(data, { type: "array" });

        // Assuming the first sheet
        const worksheet = workbook.Sheets[workbook.SheetNames[0]];
        const json = xlsx.utils.sheet_to_json(worksheet);
        setData4Import(json);
        setData4ImportSet(true);
      };
      reader.readAsArrayBuffer(file);
    }
  };
};

export function formatDateString(dateString: string): string {
  const date = new Date(dateString);
  const options: Intl.DateTimeFormatOptions = {
    year: "numeric",
    month: "long",
    day: "numeric",
  };
  return date.toLocaleDateString("en-US", options);
}

export function isDecimal(num: number): boolean {
  return num % 1 !== 0;
}

export const getCurrentDate = (): string => {
  const today = new Date();
  const year = today.getFullYear();
  const month = String(today.getMonth() + 1).padStart(2, "0"); // Months are zero-indexed
  const day = String(today.getDate()).padStart(2, "0");

  return `${year}-${month}-${day}`;
};

export const getEventStatus = (startDate: string, endDate: string) => {
  const startTimeStamp = new Date(startDate).getTime();
  const endTimeStamp = new Date(endDate).getTime();

  if (new Date().getTime() < startTimeStamp) {
    return ONGOING_REGISTERATION;
  }

  if (new Date().getTime() < endTimeStamp) {
    return JOIN_NOW;
  }

  return PAST;
};

export const getEventDaysDuration = (startDate: string, endDate: string) => {
  const startTimeStamp = new Date(startDate).getTime();
  const endTimeStamp = new Date(endDate).getTime();

  const durationInMilliSeconds = endTimeStamp - startTimeStamp;

  return durationInMilliSeconds / 1000 / 60 / 60 / 24;
};

export function getFormattedDate(date: Date) {
  const options: any = { year: "numeric", month: "long", day: "numeric" };
  return date.toLocaleDateString("en-US", options);
}

export function getPercentage(total: number, part: number) {
  return Math.round((part / total) * 100);
}

export function pricePerDay2PricePerMonth(pricePerDay: number) {
  return pricePerDay * 30;
}

export function milliSeconds2Days(milliSeconds: number) {
  return Math.round(milliSeconds / 1000 / 60 / 60 / 24);
}

export function formatNumberWithThousandsSeparator(value: number): string {
  return value.toLocaleString("en-US", {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  });
}

export function customFormatNumber(value: number): string {
  // Split the number into integer and decimal parts
  const [integerPart, decimalPart] = value.toString().split(".");

  // Add thousands separator to the integer part
  const formattedInteger = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ",");

  // Return the integer part with decimals (if any)
  return decimalPart ? `${formattedInteger}.${decimalPart}` : formattedInteger;
}

export const interpretDataIntoXlsxFormat = (data: any) => {
  let columns: any[] = [];
  let content: any[] = [];

  let newData: any[] = [];

  for (const key in data[0]) {
    columns = [
      ...columns,
      {
        label: properlizeWords(camelCase2Words(key)),
        value: key,
      },
    ];
  }

  for (const order of data) {
    content = [...content, order];
  }

  newData = [
    {
      sheet: "RentalOrders",
      columns,
      content,
    },
  ];

  return newData;
};
